import { apiRequest } from "util/services";

/**
 * True when the org has at least one dashboard Advisor can use.
 * Fail open on API errors so a bad list payload cannot hide chat.
 */
export async function orgHasAdvisorDashboards() {
  const result = await apiRequest(
    "dashboards/all",
    "POST",
    { start_index: 0, num_dashboards: 1, sort: "newest" },
    true
  );
  if (!result || result.cancel || result.error) {
    return true;
  }
  const list = result.dashboards || result.success?.dashboards;
  return Array.isArray(list) && list.length > 0;
}
